import { DateRange, isRelativeRange, RelativeValue } from '@logz-pkg/utils';
import moment from 'moment-timezone';
import { parseRelativeTimeToManualInput } from '../ManualInputSection';

export const getDisplayPartsFromDateRange = (
  dateRange: DateRange | null,
  timezone?: string,
): { mainPart: string; timePart: string } => {
  if (!dateRange) {
    return { mainPart: '', timePart: '' };
  }

  if (isRelativeRange(dateRange)) {
    const parsedInput = parseRelativeTimeToManualInput(dateRange.start.value as RelativeValue);

    if (!parsedInput || parsedInput.value === '' || parsedInput.value === 0) {
      return { mainPart: '', timePart: '' };
    }

    const { value, unit } = parsedInput;

    const unitName = unit.replace(/s$/, ''); // Remove 's' from plural forms
    const pluralUnit = value === 1 ? unitName : `${unitName}s`;
    const mainPart = `Last ${value} ${pluralUnit}`;

    const now = timezone ? moment.tz(timezone) : moment();
    const momentUnit = unit as moment.unitOfTime.DurationConstructor;
    const startTime = now.clone().subtract(value, momentUnit);
    const timePart = `(${startTime.format('HH:mm')} - Now)`;

    return { mainPart, timePart };
  }

  try {
    const startMoment = timezone ? moment.tz(dateRange.start.value, timezone) : moment(dateRange.start.value);
    const endMoment = timezone ? moment.tz(dateRange.end.value, timezone) : moment(dateRange.end.value);
    const dateTimeFormat = 'MMM DD, HH:mm';
    const mainPart = `${startMoment.format(dateTimeFormat)} - ${endMoment.format(dateTimeFormat)}`;

    return { mainPart, timePart: '' };
  } catch (error) {
    return { mainPart: '', timePart: '' };
  }
};
